import { IGatsbyImageData } from "gatsby-plugin-image";
import React from "react";
import { IVideo } from "../shared/Visual";
import { ImageHero } from "./ImageHero";
import { TextHero } from "./TextHero";
import { VideoHero } from "./VideoHero";

export const Hero: React.FC<{
  image?: IGatsbyImageData | null;
  video?: IVideo | null;
  externalVideoUrl?: string | null;
  alt?: string | null;
  title?: string | null;
  heading?: string | null;
  description?: string | null;
}> = ({ image, alt, video, externalVideoUrl, title, heading, description }) => {
  if (video && image) {
    return (
      <VideoHero
        image={image}
        alt={alt}
        video={video}
        externalVideoUrl={externalVideoUrl}
        title={title}
        heading={heading}
      />
    );
  }

  if (image) {
    return (
      <ImageHero image={image} alt={alt} title={title} heading={heading} />
    );
  }
  return <TextHero title={title} heading={heading} description={description} />;
};
